<template>
    <div class="table-list account-mgt-list">
        <modal class="del-account" :display="modalState.delAccountModal" @modalStatus="closeModal('delAccountModal')" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>刪除帳號</h1>
            <div class="content">
                確定要刪除“{{delAccountData.accountName}}”帳號嗎？確定後將直接刪除此帳號
            </div>
            <div class="btn-group">
                <button class="default-button" @click="delAccount()">確認</button>
                <button class="border-button" @click="closeModal('delAccountModal')">取消</button>
            </div>
        </modal>
        <modal class="del-account" :display="modalState.notDeleteModal" @modalStatus="closeModal('notDeleteModal')" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>業務有房源時，不得刪除</h1>
            <div class="content">
                您可以至批量分派業務，把此業務的房源分配給其他業務
            </div>
            <div class="btn-group">
                <button class="default-button" @click="toDispatch">批量分派業務</button>
            </div>
        </modal>
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="name">名稱</span>
            <span class="account">帳號</span>
            <span class="group">業務分群</span>
            <span class="role">職務部門</span>
            <span class="login-time">最後登入紀錄</span>
            <span class="create-date">建立時間</span>
            <span class="audit">認證狀態</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-if="isLoading" class="filter-empty">
                <table-loading />
            </div>
            <div v-else-if="filterByWord.length == 0 && accountList.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <button class="default-button" @click="setFilterDefault">清除篩選</button>
            </div>
            <div v-else-if="accountList.length == 0" class="is-empty">0 筆資料</div>
            <ul v-else>
                <li v-for="(list,index) in filterByWord" :key="index">
                    <span class="name">
                        <span class="test-profile-pic profile-pic"></span>
                        <img :src="list.profilePic"/>
                        {{list.name}}
                    </span>
                    <span class="account">
                        {{list.account.length >= 20?compressWord(list.account, 20):list.account}}
                        <div v-if="list.account.length >= 20" class="full-word">
                            <span>
                                {{list.account}}
                            </span>
                        </div>
                    </span>
                    <span class="group">{{list.groupName}}</span>
                    <span class="role">{{list.roleName}}</span>
                    <span class="login-time">{{list.lastLoginDate?getFormatDateTime(list.lastLoginDate,true):'-'}}</span>
                    <span class="create-date">{{getFormatDateTime(list.createdDate)}}</span>
                    <span class="audit">
                        <span class="blue" v-if="list.audited">已認證</span>
                        <span class="red" v-else>未認證</span>
                    </span>
                    <span class="action">
                        <dot-drop-menu>
                            <ul>
                                <router-link :to="{ name: 'bizViewAccount', query: {cId: list.userCid}}">
                                    <li>查看帳號</li>
                                </router-link>
                                <router-link :to="{ name: 'bizEditAccount', query: {cId: list.userCid}}"
                                    v-if="bizAuth.editUser.hasRight">
                                    <li>編輯帳號</li>
                                </router-link>
                                <li v-if="bizAuth.deleteUser.hasRight" @click="openDelModal(list)">刪除帳號</li>
                            </ul>
                        </dot-drop-menu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';
import { mapGetters } from 'vuex'
export default {
    data () {
        return{
            delAccountData: {
                accountId: null,
                accountName: null,
            },
            modalState: {
                delAccountModal: false,
                notDeleteModal: false
            },
            isLoading: true
        }
    },
    props: {
        
    },
    watch: {
        
    },
    mounted() {
        this.getAccountList();
    },
    methods: {
        getAccountList: function () {
            this.$store.dispatch('getBizAccountList')
            .then(()=>{
                this.isLoading = false
            })
        },
        setFilterDefault: function () {
            // TODO
        },
        openDelModal: function (item){
            console.log(item)
            this.delAccountData.accountId = item.userCid 
            this.delAccountData.accountName = item.name
            if(item.manager){
                this.$store.dispatch('setAlarmStatus', {status: true,title: '不能刪除第一個管理者',type: 'error'})
            }else if(item.hasHouse){
                this.modalState.notDeleteModal = true
            }else{
                this.modalState.delAccountModal = true
            }
            
        },
        toDispatch: function () {
            this.$router.push({name: 'bizBatchDispatch', query: {sales: this.delAccountData.accountName}})
        },
        // 刪除帳號
        delAccount: function () {
            console.log('123')
            this.$analyticsBiz.logEvent('刪除帳號', { screen_name: '刪除帳號'})
            this.$store.dispatch('delBizAccount', this.delAccountData.accountId)
            .then(res => {
                if(res.data.status = "SUCCESS"){
                    this.modalState.delAccountModal = false
                    this.getAccountList()
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '刪除帳號成功',type: 'error'})
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '刪除帳號失敗',type: 'error'})
                }
            })
            .catch(err => {
                this.$store.dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
                console.log(err)
            })
        },
        // 關閉角色modal
        closeModal: function () {
            this.modalState.delAccountModal = false
            this.modalState.notDeleteModal = false
        },
    },
    computed: {
        filterByWord: function () {
            return this.accountList.filter((item) => {
                if( this.filterWord ){
                    if( item.roleName.includes(this.filterWord) ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            accountList: 'GET_BIZ_ACCOUNT_LIST',
            filterWord: 'GET_BIZ_ACCOUNT_FILTER_WORD',
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        DotDropMenu,
        Modal,
        tableLoading
    }
}
</script>
<style lang="scss">
    // test TODO start
    .test-profile-pic{
        width: 24px;
        height: 24px;
        margin-right: 8px;
        background-color: #d8d8d8;
        border-radius: 50%;
    }
    // test TODO end

    .table-list.account-mgt-list{
        margin-bottom: 150px;
        .table-list-title .name,
        .table-list-body ul li .name{
            width: 135px;
            margin-right: 33px;
            display: flex;
            align-items: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            .profile-pic {
                width: 24px;
                height: 24px;
                margin-right: 8px;
                border-radius: 50%;
            }
        }
        .table-list-title .account,
        .table-list-body ul li .account{
            width: 170px;
            margin-right: 30px;
        }
        .table-list-title .group,
        .table-list-body ul li .group{
            width: 148px;
            margin-right: 30px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .table-list-title .role,
        .table-list-body ul li .role{
            width: 125px;
            margin-right: 30px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .table-list-title .login-time,
        .table-list-body ul li .login-time{
            width: 110px;
            margin-right: 30px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .table-list-title .create-date,
        .table-list-body ul li .create-date{
            width: 72px;
            margin-right: 30px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .table-list-title .audit,
        .table-list-body ul li .audit{
            width: 76px;
            margin-right: 30px;
            >span{
                width: 76px;
                height: 38px;
                border-radius: 4px;
                font-weight: 500;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .red{
                background-color: rgba(255, 146, 117, 0.1);
                color: #fc7171;
            }
            .blue{
                background-color: rgba(113, 170, 229, 0.1);
                color: #71aae5;
            }
        }
        
        .table-list-title .action,
        .table-list-body ul li .action{
            width: 28px;
        }
        #modal.del-account{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1280px){
        // .table-list.account-mgt-list{
            
        // }
    
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/internalAuth/accountMgt/accountMgtList.vue